import Assignee from 'models/assignee';
import Conversation from 'models/conversation';
import SwitchCurrentConversation from 'actions/customer/switch_current_conversation';
import UpdateCurrentComposition from 'actions/composition/update_current_composition';
import ConvDtoConverter from 'scripts/application/dto_converters/conversation_converter';
import { getDefaultRoutingGroupIdForAgent } from 'actions/conversation/lib/get_default_routing_groupId_for_agent';
import { getLatestConversationAttributes } from 'actions/conversation/lib/conversation_helpers';

export default class CreateConversation {
  constructor(context) {
    this.context = context;
  }

  get conversationStore() {
    return this.context.stores.customers.storesFor(this.currentCustomerId).conversations;
  }

  get currentCustomerId() {
    return this.context.stores.currentLocation.get().customerId;
  }

  get currentAgentId() {
    return this.context.stores.currentAgent.get().id;
  }

  run({ routingGroupId } = {}) {
    if (!routingGroupId) {
      routingGroupId = this.getLatestConversationRoutingGroupId() ?? getDefaultRoutingGroupIdForAgent(this.context);
    }

    const agentId = this.currentAgentId;

    const conversation = Conversation.create({
      assignee: new Assignee({ routingGroupId, agentId }),
      status: Conversation.Status.OPEN,
      conversationItems: [],
    });

    this.conversationStore.setPendingNew(conversation);
    this.context.gateways.customerHistory.addConversation(this.currentCustomerId, ConvDtoConverter.toDto(conversation));

    const conversationId = conversation.id;
    this.context.executeAction(SwitchCurrentConversation, { conversationId });
    this.context.executeAction(UpdateCurrentComposition, conversationId);
  }

  /**
   * Returns the last conversation's routing group id if it's still enabled.
   * @returns {undefined|*}
   */
  getLatestConversationRoutingGroupId() {
    const routingGroupId = getLatestConversationAttributes(this.conversationStore, ['assignee'])?.assignee
      .routingGroupId;

    const routingGroup = routingGroupId && this.context.stores.routingGroups.findBy({ id: routingGroupId });

    if (routingGroup && !routingGroup.disabled) {
      return routingGroupId;
    }

    return undefined;
  }
}
